<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <form class="kt-form w-webkit-fill-available" [formGroup]="form">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">{{ 'Blast Setting' | translate }}</h5>
        <span class="modal-x-button" (click)="onCloseDialog()">
            <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 form-group">
            <label class="control-label">{{ 'Batch Interval (Minutes)' | translate }} <span class="text-danger">* </span>
              <i class="fas fa-exclamation-circle"
                matTooltip="Minutes with no new recipient before a campaign is sent to Cloud Marketing. Every new recipient restarts this countdown."
                matTooltipClass="custom-tooltip"
                matTooltipHideDelay="0"
                matTooltipPosition="right"></i>
            </label>
            <input type="number" (wheel)="false" formControlName="batch_interval_minutes" min="5" max="1440" class="form-control">
            <small class="text-muted input-msg">
              <i class="fa fa-exclamation-circle"></i> Between 5 and 1440 minutes
            </small>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 form-group">
            <label class="control-label">{{ 'Batch Send Limit' | translate }} <span class="text-danger">* </span>
              <i class="fas fa-exclamation-circle"
                matTooltip="Recipient count that sends the campaign immediately, without waiting for the batch interval."
                matTooltipClass="custom-tooltip"
                matTooltipHideDelay="0"
                matTooltipPosition="right"></i>
            </label>
            <input type="number" (wheel)="false" formControlName="batch_send_limit" min="150" max="100000" class="form-control">
            <small class="text-muted input-msg">
              <i class="fa fa-exclamation-circle"></i> Between 150 and 100000 recipients
            </small>
          </div>
        </div>

        <div class="col-12 p-0" *ngIf="data.setting">
          <table class="col-12">
            <tr>
              <td>
                Updated by: {{ data.setting.updated_by ? data.setting.updated_by + '&nbsp;' : '-&nbsp;' }}{{ data.setting.updated_at | timezoneDate:'YYYY-MM-DD HH:mm' }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>{{ 'Close' | translate }}</button>
        <kt-submit-button [isDisabled]="!form.valid" [buttonLoading]="buttonLoading" (confirmed)="onSave()"></kt-submit-button>
      </div>
    </div>
  </form>
</div>
<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog($event, true)"></kt-swal-alert>
